// extracted by mini-css-extract-plugin
module.exports = {"Center":"Confirmation_Center__3o4k5"};